import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  CorrectiveActionPayload,
  VehicleCheckCommonResponse,
  VehicleCheckPayload,
  VehicleCheckResponse,
  VerifiedPayload,
} from '@core/interface/fleet/daily-vehicle-check';
import {
  VehicleResponse,
  Vehicle,
  AddVehicleResponse,
  VehicleCommonResponse,
} from '@core/interface/fleet/vehicle';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class FleetService {
  constructor(private http: HttpClient) {}

  getVehicleInspectedList(filter?: VehicleCheckPayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof VehicleCheckPayload] as any) || ''
        );
      });
    return this.http.get<VehicleCheckResponse>(
      environment.endPoints.dailyVehicleInspectionList,
      {
        params: httpParams,
      }
    );
  }

  getVehicleList(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<VehicleResponse>(environment.endPoints.vehicleList, {
      params: httpParams,
    });
  }

  updateVehicle(data?: Vehicle) {
    return this.http.post<AddVehicleResponse>(
      environment.endPoints.vehicleAddEdit,
      data
    );
  }

  markAsVerified(data?: VerifiedPayload) {
    return this.http.post<VehicleCheckCommonResponse>(
      environment.endPoints.VehicleInspectionVerified,
      data
    );
  }

  updateCorrectiveAction(data?: CorrectiveActionPayload[]) {
    return this.http.post<any>(
      environment.endPoints.VehicleInspectionCorrectiveAction,
      data
    );
  }

  deleteVehicle(id: number) {
    return this.http.get<VehicleCommonResponse>(
      environment.endPoints.vehicleDelete(id)
    );
  }
}
